export const graphemes = new Intl.Segmenter(undefined, { granularity: 'grapheme' });
